import classes from './Testimonials.module.scss';
import TestimonialsCarousel from '../../organisms/testimonialsCarousel/TestimonialsCarousel';
import testimonialSettings from './config/carouselSettings.json';

export default function Testimonials(props) {
    /**
     * return null needed for react render func
     */
    if (!props) return null;

    const siteContent = props[0];
    const testimonialContent = [props[1], props[2], props[3]];

    return (
        <div className={`${classes.oCarouselPanel} oCarouselTestimonials`}>
            <div className={`container`}>
                <div className={`row no-gutters`}>
                    <h2 className={`aSectionTitle _accent fntH2`}>{siteContent.site_header}</h2>
                </div>
            </div>
            <TestimonialsCarousel config={testimonialSettings} content={testimonialContent} />

            <div className={classes.oBackgroundBlock}>
                <svg
                    className={classes.aBgSvgBean}
                    width="205"
                    height="554"
                    viewBox="0 0 205 554"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M47.5094 495.059C98.4771 601.807 222.303 539.537 277.844 495.059L280.785 495.059L280.785 39.0703C279.805 31.7157 255.693 13.8544 167.088 1.24637C56.331 -14.5137 -6.39861 123.124 1.44257 191.417C9.28375 259.71 100.438 282.825 85.7353 339.561C71.033 396.297 -16.2002 361.625 47.5094 495.059Z"
                        fill="url(#paint0_linear_1841_11274)"
                        fillOpacity="0.7"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1841_11274"
                            x1="-121.805"
                            y1="277"
                            x2="208.589"
                            y2="176.141"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="#FEE4AE" />
                        </linearGradient>
                    </defs>
                </svg>
                <span className={`${classes.aBgCircle} ${classes.Orange1}`} />
            </div>
        </div>
    );
}
